module.exports = __webpack_public_path__ + "media/img/calendar/outlook-a17295562be51c1ad9c6a7431e91a832.png";